export default __webpack_public_path__ + "static/media/Brand-Web-Logo.fb03ec24.png";